package org.example.project.yard

import org.example.project.utils.All
import kotlin.js.Date

const val WA_SAMMEL_PIN_FIELD = "waSammelPin"
const val WA_SAMMEL_ID_FIELD = "waSammelId"
const val WA_SAMMEL_PIN_EXTRA = WA_SAMMEL_PIN_FIELD
const val WA_SAMMEL_ID_EXTRA = WA_SAMMEL_ID_FIELD

fun yardPinBestaetigt(entry: All): Boolean =
    entry.pinBestaetigt

fun yardPinBestaetigtLabel(entry: All): String =
    if (yardPinBestaetigt(entry)) "\u2705" else "\u2B1C"

fun yardPinCode(entry: All): String {
    val storedPin = entry.waSammelPin
        .ifBlank { entry.waSammelId }
        .ifBlank { entry.pin }
        .trim()
    if (storedPin.isNotBlank()) return storedPin

    val source = listOf(
        yardPinDateKey(),
        entry.firmenId,
        entry.auftragsart,
        entry.id,
        entry.lfdNr.toString(),
        entry.lieferscheinnummer,
        entry.lkwkennzeichen
    ).joinToString("|")

    var hash = 17
    source.forEach { char ->
        hash = ((hash * 31) + char.code) and Int.MAX_VALUE
    }
    return ((hash % 9000) + 1000).toString()
}

private fun yardPinDateKey(): String {
    val date = Date()
    val year = date.getFullYear().toString()
    val month = (date.getMonth() + 1).toString().padStart(2, '0')
    val day = date.getDate().toString().padStart(2, '0')
    return "$year-$month-$day"
}
